<template>
  <div
    id="element"
    class="register-status"
  >
    <div class="register-status--item">
      <Header/>
    </div>
    <vue-recaptcha
      ref="recaptcha"
      :sitekey="siteKey"
      size="invisible"
      @verify="sendEmail"
      @expired="onCaptchaExpired"
    />
    <div class="section-gray">
      <div class="section-white">
        <div class="register-status--title">
          <div style="margin-bottom: 32px;">
            <img
              src="/static/svg/icon-complete.svg"
              class="status-logo"
            >
            <span class="status-name">
              {{ $t('register_status.title') }}
            </span>
          </div>
          {{ $t('register_status.you_have_got_email') }}
        </div>
        <div class="register-status--detail">
          {{ $t('register_status.please_confirm_email') }}
        </div>
        <div v-if="$route.query.opts === 'facebookNoEmail'">
          <div class="register-status--detail">
            {{ $t('register_status.if_not_receive_email_facebook') }}
          </div>
          <a
            class="send-email-btn"
            @click="logout"
          >
            {{ $t('menu.logout') }}
          </a>
        </div>
        <div v-else>
          <div class="register-status--detail">
            {{ $t('register_status.if_not_receive_email_facebook') }}
          </div>
          <b-button
            :loading="isloading"
            class="send-email-btn"
            @click="executeRecaptcha"
          >
            {{ $t('register_status.resend_email') }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="register-status--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import Service from './service'
import { kulapApi } from '@/resources'
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import { showToastError } from '@/utils/helper'
import { RECAPTCHA_SITE_KEY } from '@/constants'
import cookie from '@/utils/cookie'

export default {
  name: 'RegisterStatus',
  components: {
    Header,
    Footer,
    VueRecaptcha
  },
  data () {
    return {
      service: null,
      siteKey: RECAPTCHA_SITE_KEY,
      isloading: false
    }
  },
  async created () {
    if (!cookie.get('user') || !cookie.get('accessToken')) {
      this.$router.push({ name: 'Exchange' })
      return
    }
    this.service = new Service({
      store: this.$store,
      kulapApi
    })
    const user = await this.service.getUserProfile()
    this.$store.dispatch('setUser', user)
    if (user.isActive) {
      this.$router.push({ name: 'Exchange' })
    }
  },
  methods: {
    executeRecaptcha () {
      this.isloading = true
      this.$refs.recaptcha.execute()
      this.$scrollTo('.register-status--item')
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
      this.isLoading = false
    },
    async sendEmail (recaptchaToken) {
      try {
        await this.service.sendConfirmationEmail(recaptchaToken)
        this.$buefy.toast.open({
          message: 'It has been done, please check your email.',
          type: 'is-success'
        })
      } catch (e) {
        showToastError(e)
      }
      this.$refs.recaptcha.reset()
      this.isloading = false
    },
    logout () {
      this.service.logout()
      setTimeout(() => {
        this.$router.push({ name: 'Exchange' })
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.register-status {
  float: left;
  width: 100%;
  min-height: 100vh;

  &--item {
    float: left;
    width: 100%;
  }

  &--title {
    margin: 0 0 25px 0;
    font-size: 21px;
    font-weight: bold;
    text-align: center;
    color: #000000;
  }

  &--detail {
    color: grey;
    text-align: center;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 170px;
  text-align: center;
}
.section-white {
  display: inline-block;
  padding: 32px 47px;
  width: fit-content;
  border-radius: 5px;
  box-shadow: 0 2px 4px -3px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  text-align: left;
}
.status-logo {
  width: 37px;
  vertical-align:middle
}
.status-name {
  font-size: 27px;
  font-weight: bold;
  vertical-align:middle
}
.send-email-btn {
  float: left;
  width: 100%;
  text-align: center;
  border: unset;
  font-size: 14px;
  cursor: pointer;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .section-gray {
    padding-bottom: 1rem;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .section-white {
    width: 95vw;
    max-width: calc(100vw - 20px);
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/RegisterStatus/index.vue